(function() {
    var animationSupport = false,
        animationString = 'animation',
        vendorPrefix = '',
        prefix = '',
        domPrefixes = ['Webkit', 'Moz', 'O', 'ms', 'Khtml'];

    $(document).ready(function(){
        var style = document.body.style;
        if( style.animationName !== undefined ) { animationSupport = true; }

        if( animationSupport === false ) {
            for( var i = 0; i < domPrefixes.length; i++ ) {
                if( style[ domPrefixes[i] + 'AnimationName' ] !== undefined ) {
                    prefix = domPrefixes[ i ];
                    animationString = prefix + 'Animation';
                    vendorPrefix = '-' + prefix.toLowerCase() + '-';
                    animationSupport = true;
                    break;
                }
            }
        }
    });


    var $createKeyframeStyleTag = function(id, css) {
        if($.keyframe.debug){ console.log(id + " " + css); }
        return $("<style>" + css + "</style>").attr({
            "class": "keyframe-style",
            id: id,
            type: "text/css"
        }).appendTo("head");
    };

    $.keyframe = {
        debug: false,
        getVendorPrefix: function() {
            return vendorPrefix;
        },
        isSupported: function() {
            return animationSupport;
        },
        generate: function(frameData) {
            var frameName = frameData.name || "";
            var css = "@" + vendorPrefix + "keyframes " + frameName + " {";

            for (var key in frameData) {
                if (key !== "name" && key !== "media" && key !== "complete") {
                    css += key + " {";

                    for (var property in frameData[key]) {
                        css += property + ":" + frameData[key][property] + ";";
                    }

                    css += "}";
                }
            }
            if(window.PrefixFree)
                css = PrefixFree.prefixCSS(css + "}");
            else 
                css += "}";
            if(frameData.media){
                css = "@media " + frameData.media + "{" + css + "}";
            }

            var $frameStyle = $("style#" + frameData.name);

            if ($frameStyle.length > 0) {
                $frameStyle.html(css);

                var $elems = $("*").filter(function() {
                    return this.style[animationString + "Name"] === frameName;
                });

                $elems.each(function() {
                    var $el = $(this);
                    var options = $el.data("keyframeOptions");
                    $el.resetKeyframe(function() {
                        $el.playKeyframe(options);
                    });
                });
            } else {
                $createKeyframeStyleTag(frameName, css);
            }
        },
        define: function(frameData) {
            if (frameData.length) {
                for (var i = 0; i < frameData.length; i++) {
                    var frame = frameData[i];
                    this.generate(frame);
                }
            } else {
                this.generate(frameData);
            }
        }
    };

    var animationPlayState = "animation-play-state";
    var playStateRunning = "running";

    $.fn.resetKeyframe = function(callback) {
        var $el = $(this).css(vendorPrefix + animationPlayState, playStateRunning).css(vendorPrefix + "animation", "none");

        if (callback) {
            setTimeout(callback, 1);
        }
    };

    $.fn.pauseKeyframe = function() {
        $(this).css(vendorPrefix + animationPlayState, "paused");
    };

    $.fn.resumeKeyframe = function() {
        $(this).css(vendorPrefix + animationPlayState, playStateRunning);
    };

    $.fn.playKeyframe = function(frameOptions, callback) {
        
        var animObjToStr = function(obj){
            obj = $.extend({
                duration: '0s',
                timingFunction: "ease",
                delay: '0s',
                iterationCount: 1,
                direction: "normal",
                fillMode: "forwards"
            }, obj);
            return [obj.name, obj.duration, obj.timingFunction, obj.delay, obj.iterationCount, obj.direction, obj.fillMode].join(" ");
        };

        var animationcss = "";

        if($.isArray(frameOptions)){
            var frameOptionsStrings = [];
            for(var i = 0; i < frameOptions.length; i++){
                if (typeof frameOptions[i] === 'string') {
                    frameOptionsStrings.push(frameOptions[i]);
                }else{
                    frameOptionsStrings.push(animObjToStr(frameOptions[i]));
                }
            }
            animationcss = frameOptionsStrings.join(", ");
        }else if (typeof frameOptions === 'string') {
            animationcss = frameOptions;
        }else{
            animationcss = animObjToStr(frameOptions);
        }

        var animationkey = vendorPrefix + "animation";
        var pfx = ["webkit", "moz", "MS", "o", ""];

        if(!callback && frameOptions.complete){
            callback = frameOptions.complete;
        }

        var _prefixEvent = function(element, type, callback) {
            for(var i = 0; i < pfx.length; i++){
                if (!pfx[i]) {
                    type = type.toLowerCase();
                }
                var evt = pfx[i] + type;
                element.off(evt).on(evt, callback);
            }
        };

        this.each(function() {
            var $el = $(this).addClass("boostKeyframe").css(vendorPrefix + animationPlayState, playStateRunning).css(animationkey, animationcss).data("keyframeOptions", frameOptions);
            if($.keyframe.debug){
                console.group();
                if(vendorPrefix){ console.log("Vendor Prefix: " + vendorPrefix); }
                console.log("Style Applied: " + animationcss);
                var testCss = $el.css(animationkey);
                console.log("Rendered Style: " + (testCss ? testCss : $el[0].style.animation));
                console.groupEnd();
            }
            if (callback) {
                _prefixEvent($el, 'AnimationIteration', callback);
                _prefixEvent($el, 'AnimationEnd', callback);
            }
        });
        return this;
    };

    $createKeyframeStyleTag("boost-keyframe", " .boostKeyframe{" + vendorPrefix + "transform:scale3d(1,1,1);}");

}).call(this);



/**
 * Material Spinner @ 0.0.9
 * @author Lei Lei
 * MIT License
 */

class Spinner {
  constructor(element, options) {
    const time = Date.now();
    this.options = options;
    this.$element = $(element);

    this.realRadius = this.options.radius - this.options.strokeWidth;

    this.rotateName = 'spin-rotate-' + time;
    this.dashName = 'spin-dash-' + time;

    this.defineKeyframes();
    this.createSvg();
  }
  defineKeyframes() {
    const dashSpace = this.options.radius * 8;
    const dashLength = [
      1,
      (this.realRadius * 4.7).toFixed(1),
      (this.realRadius * 4.7).toFixed(1)
    ];
    const dashOffset = [
      '0',
      (0 - (this.realRadius * 1.75)).toFixed(1),
      (0 - (this.realRadius * 6.23)).toFixed(1)
    ];
    $.keyframe.define([{
      name: this.rotateName,
      from: {
        'transform': 'rotate(0deg)'
      },
      to: {
        'transform': 'rotate(360deg)'
      }
    }, {
      name: this.dashName,
      '0%': {
        'stroke-dasharray': dashLength[0] + ',' + dashSpace,
        'stroke-dashoffset': dashOffset[0]
      },
      '50%': {
        'stroke-dasharray': dashLength[1] + ',' + dashSpace,
        'stroke-dashoffset': dashOffset[1]
      },
      '100%': {
        'stroke-dasharray': dashLength[2] + ',' + dashSpace,
        'stroke-dashoffset': dashOffset[2]
      }
    }]);
  }
  createSvg() {
    const {radius, strokeWidth} = this.options;
    const dashSpace = this.options.radius * 8;
    this.$element.append(this.makeSvg('svg', {
      width: radius * 2,
      height: radius * 2
    }));
    const $svg = this.$element.find('svg');
    $svg.append(this.makeSvg('circle', {
      cx: radius,
      cy: radius,
      r: this.realRadius,
      fill: 'none',
      'stroke-width': strokeWidth
    }));
    const $circle = $svg.find('circle').css({
      'stroke-dasharray': '1,' + dashSpace,
      'stroke-dashoffset': '0',
      'stroke-linecap': 'round',
      'stroke': this.options.color
    });
    $svg.playKeyframe(
      this.rotateName + ' ' + this.options.duration + 's linear infinite'
    );
    const circleDuration = this.options.duration / 4.0 * 3.0;
    $circle.playKeyframe(
      this.dashName + ' ' + circleDuration.toFixed(1) + 's ease-in-out infinite'
    );
  }
  makeSvg(tag, attrs) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    for (const k in attrs) {
      el.setAttribute(k, attrs[k]);
    }
    return el;
  }
}

Spinner.VERSION = '0.0.1';

Spinner.DEFAULTS = {
  radius: 25,
  strokeWidth: 5,
  duration: 2,
  color: '#3f88f8'
};

function Plugin(option) {
  return this.each(() => {
    const $this = $(this);
    const options = $.extend({}, Spinner.DEFAULTS, option);

    if (!$this.data('spinnerHandler')) {
      $this.data('spinnerHandler', new Spinner(this, options));
    }
  });
}

$.fn.materialSpinner = Plugin;
$.fn.materialSpinner.Constructor = Spinner;

// Register data api
$(window).on('load', () => {
  $('[data-spinner]').each(function() {
    const $this = $(this);
    const option = $this.data('spinner');
    if (!$this.data('spinnerHandler')) {
      Plugin.call($this, option, this);
    }
  });
});


// WEBPACK FOOTER //
// ./app/javascript/components/ui/Spinner.js